<template lang="pug">
	.project-settings-assets
		div.total-size
			.assets-size
				AssetCompressionData(sizeText="Total size of assets: " :assets="_.filter(projectAssets, asset => ['image', 'atlas', 'sound', 'json', 'three-glb', 'three-fbx'].includes(asset.type) && (asset.type !== 'image' || !asset.Tags.parsed) && (asset.type !== 'atlas' || (asset.Tags && asset.Tags.custom) || (asset.Tags && asset.Tags.parsed)))")
		div(v-for="assetsGroup in assetsGroups")
			.asset-type.clearfix.mt-4(v-if="(assetsGroup.assets && assetsGroup.assets.length) || assetsGroup.isExtendable")
				.asset-type-header
					.asset-type-title {{ assetsGroup.title }}
					.asset-type-add(v-if="assetsGroup.isExtendable" @click="addAsset(assetsGroup)" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: assetsGroup.extendTitle}")
						i.fa.fa-plus
				.assets-size
					AssetCompressionData(:assets="_.filter(assetsGroup.assets, asset => asset.type !== 'image' || (asset.Tags && !asset.Tags.parsed))")
				.progress.add-progress(:style="{visibility: assetsGroup.isUploading ? 'visible' : 'hidden'}")
					.progress-bar.progress-bar-striped.progress-bar-animated(role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" :style="{width: (assetsGroup.uploadProgress * 100) + '%'}")
				.asset-type-description
					small.text-muted(v-if="assetsGroup.assets && assetsGroup.assets.length" v-html="assetsGroup.description")
					small.text-muted(v-else v-html="assetsGroup.emptyText")
				.assets-list(v-if="assetsGroup.assets && assetsGroup.assets.length")
					.assets-list-item(v-for="asset in assetsGroup.assets" v-on:click="expandAsset(asset, $event)" :class="{'disabled': asset.Tags && asset.Tags.disabled}" @mouseover="onAssetOver(asset, $event)" @mouseout="onAssetOut(asset, $event)" v-pseudo-modal-name="'asset-settings-' + asset.id")
						.asset-list-main
							.asset-list-name
								span(v-if="assetsGroup.title === 'Videos'") {{asset.title}}
								span(v-else) {{ getAssetTitle(asset) }}
							.asset-list-edit(v-if="isAssetsChangesAllowed")
								.asset-list-edit-item(v-if="asset.isChanged")
									i.icon-info.icons.font-2xl(v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'This asset was changed'}")
								.asset-list-edit-item(v-if="asset.Tags && asset.Tags.disabled")
									i.icon-info.icons.font-2xl(v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'This asset is disabled and not uses in the creative'}")
								.asset-list-edit-item.control-item.asset-list-edit-reset(v-if="asset.isChanged" @click="resetAsset(asset)" v-b-tooltip.hover="{delay: { show: 1500, hide: 100 }, title: 'Reset to default'}")
									i.fa.fa-rotate-left
								.asset-list-edit-item.control-item.asset-list-edit-download(v-if="assetsGroup.isDownloadable" @click="downloadAsset(asset)" v-b-tooltip.hover="{delay: { show: 1500, hide: 100 }, title: 'Download asset'}")
									i.fa.fa-download
								.asset-list-edit-item.control-item.asset-list-edit-replace(v-if="assetsGroup.isReplaceable" @click="replaceAsset(asset)" v-b-tooltip.hover="{delay: { show: 1500, hide: 100 }, title: 'Replace asset'}")
									i.fa.fa-upload
								.asset-list-edit-item.control-item.asset-list-edit-close(v-if="assetsGroup.isRemovable" :class="{custom: asset.Tags && asset.Tags.custom, parsed: (asset.Tags && asset.Tags.parsed)}" @click="removeAsset(assetsGroup, asset)" v-b-tooltip.hover="{delay: { show: 1500, hide: 100 }, title: asset.Tags && asset.Tags.custom ? 'Delete asset' : (asset.Tags && asset.Tags.disabled ? 'Enable asset' : 'Disable asset')}")
									i.fa(:class="{'fa-times': (asset.Tags && !asset.Tags.disabled) || (asset.guid && !asset.disabled), 'fa-refresh': (asset.Tags && asset.Tags.disabled) || (asset.guid && asset.disable)}")
						.progress(v-if="asset.isUploading")
							.progress-bar.progress-bar-striped.progress-bar-animated(role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" :style="{width: (asset.uploadProgress * 100) + '%'}")
						.asset-list-item-settings
							.asset-settings.image-settings(v-if="assetsGroup.type === 'image' && expandedAssetId === asset.id")
								.asset-settings-control.multi-select-control.in-a-row.low-margin.separated
									AssetCompressionData(:assets="[asset]")
								.asset-settings-control
									span.title Override url
									input.form-control.form-control-sm(type="text" :value="asset.AdditionalData.overriddenUrl" v-on:input="setImageOverriddenUrl(asset, $event.target.value)" v-on:change="Asset.setAssetProperty(asset, 'overriddenUrl', $event.target.value)")
								.asset-settings-control.compression-activated(v-if="asset.isJPG")
									span.title {{asset.hasCompression ? 'Quality: ' + (parseInt(asset.mergedAssetData["compression"] * 100)) + '%' : 'Custom compression'}}
									label.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
										input.switch-input.form-check-input(type="checkbox" :checked="asset.hasCompression" @change="setImageCompressionLevel(asset, $event.target.checked ? 80 : null)")
										span.switch-slider(data-checked="On" data-unchecked="Off")
										span.switch-handle
								.asset-settings-control.compression-control(v-if="asset.hasCompression && asset.isJPG")
									span.title
									input.custom-range(type="range" :min="1" :max="100" :step="1" :value="asset.mergedAssetData['compression'] * 100" v-on:input="setImageCompressionLevel(asset, $event.target.value)")
								.asset-settings-control.compression-activated
									span.title Tinypng optimization
									label.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
										input.switch-input.form-check-input(type="checkbox" :checked="!!asset.mergedAssetData.tinyPng" @change="setImageTinyPng(asset, $event.target.checked)")
										span.switch-slider(data-checked="On" data-unchecked="Off")
										span.switch-handle


</template>

<script>

	import Screen 				from './../../mixins/screen';

	import { Project } 			from '../../services/Project';
	import { Asset } 			from '../../services/Asset';

	import AssetCompressionData from './../Shared/AssetCompressionData';
	import AssetVideoCreate		from "./AssetVideoCreate";

	export default {
		name: "SettingsContentAssets",
		mixins: [Screen],
		screen: {
			updateOn: ["Selected Project Changed", "Selected Project Assets Changed", "Settings Tab Changed", "Assets Updated", 'Video Removed', 'Video Created', 'Selected Template Changed'],
			events: {
				"Asset Upload Progress": function() {

					this.update();

				},
				"Pseudo Modal Process Hide": function(names) {

					if (!_.find(names, n => n.indexOf('asset-settings-') === 0) && !_.includes(names, 'items-dropdown')) this.collapseAsset();

				}
			}
		},
		components: {
			AssetCompressionData,
			AssetVideoCreate
		},
		data() {

			this.Asset = Asset;
			this.Monitoring = Monitoring;
			this.Metadata = Metadata;
			this._ = window._;

			//this.isExtendable = Template.SelectedTemplate && Template.SelectedTemplate.id === 4;

			this.assetsGroups = {
				'image': {
					type: 'image',
					title: 'Images',
					description: 'Here you can replace images',
					isRemovable: true, // Возможно ли отключить ассет
					isExtendable: true, // Возможно ли добавить новый ассет
					isReplaceable: true, // Возможно ли заменить ассет
					isDownloadable: true, // Возможно ли скачать ассет
					assetAddTypes: []
				},
				'video': {
					type: 'video',
					title: 'Videos',
					description: 'Here you can replace videos',
					extendTitle: 'Add new video',
					isRemovable: true,
					isExtendable: true,
					isReplaceable: false,
					isDownloadable: false,
					assetAddTypes: []
				}
			};

			this.projectAssets = {};

			return {
				showed: true,
				isAssetsChangesAllowed: false,
				expandedAssetId: null
			};

		},
		methods: {
			collectData() {

				this.projectAssets = Asset.getSelectedProjectAssets();

				_.each(this.assetsGroups, config => config.assets = []);

				_.each(this.projectAssets, asset => {

					if (this.assetsGroups[asset.type]) {

						this.assetsGroups[asset.type].assets.push(asset);

					}
					else if (this.assetsGroups['image'] && asset.type === 'svg') {

						this.assetsGroups['image'].assets.push(asset);

					}

				});

				if (this.assetsGroups['image']) {
					//this.assetsGroups['image'].isExtendable = Template.SelectedTemplate && Template.SelectedTemplate.id === 4;
				}

				if (Asset.getVideos())
					this.assetsGroups.video.assets = Object.values(Asset.getVideos());

				this.isAssetsChangesAllowed = true;

			},
			getAssetTitle(asset) {

				return asset.codename;

			},
			addAsset(assetsGroup) {

				if (assetsGroup.type === 'image') {

					let input = document.createElement('input');
					input.type = 'file';
					input.style.position = 'absolute';
					input.style.left = '0';
					input.style.top = '0';
					input.style.transform = 'scale(0.1)';
					input.style.visibility = 'hidden';
					document.body.appendChild(input);

					input.accept = "image/png, image/jpeg";

					input.addEventListener('change', e => {

						let file = e.target.files[0];

						Asset.addAsset(assetsGroup, file);

						document.body.removeChild(input);

					});

					input.addEventListener('blur', e => {

						document.body.removeChild(input);

					});

					input.click();
				}

				if (assetsGroup.type === 'video') {

					Broadcast.call("Show Asset Video Create");

				}

			},
			downloadAsset(asset) {

				Asset.downloadAsset(asset);

			},
			replaceAsset(asset) {

				let input = document.createElement('input');
				input.type = 'file';
				input.style.position = 'absolute';
				input.style.left = '0';
				input.style.top = '0';
				input.style.transform = 'scale(0.1)';
				input.style.visibility = 'hidden';
				document.body.appendChild(input);

				if (asset.type === 'image' || asset.type === 'svg') input.accept = "image/png, image/jpeg, image/svg+xml";

				input.addEventListener('change', e => {

					let file = e.target.files[0];

					Asset.replaceAsset(asset, file);

					if (asset.audioInstance) delete asset.audioInstance;

					document.body.removeChild(input);

				});

				input.click();

			},
			resetAsset(asset) {

				Asset.resetAsset(asset);

			},
			onAssetOver(asset, e) {

				let el = e.currentTarget;

				Broadcast.call("Show Asset Preview", [asset, e, el]);

			},
			onAssetOut(asset, e, el) {

				Broadcast.call("Hide Asset Preview", [asset, e, el]);

			},
			removeAsset(assetConfig, asset) {


				if ((asset.Tags && asset.Tags.custom) || asset.guid) {

					Asset.removeAsset(asset);

				} else {

					if (asset.Tags.disabled) Asset.enableAsset(asset);
					else Asset.disableAsset(asset);

				}

			},
			expandAsset(asset, event) {

				if (event.target.closest('.asset-list-main .asset-list-edit')) return;

				this.expandedAssetId = asset.id;

			},
			collapseAsset() {

				this.expandedAssetId = null;

			},
			setImageTinyPng(asset, tiny_png) {

				Asset.setAssetProperty(asset, 'tinyPng', tiny_png);

			},
			setImageOverriddenUrl(asset, overriddenUrl) {

				Asset.setAssetProperty(asset, 'overriddenUrl', overriddenUrl);

			},
			setImageCompressionLevel(asset, level) {

				if (level === null) {
					delete asset.mergedAssetData.compression;
					asset.hasCompression = false;
				} else {
					asset.mergedAssetData.compression = parseInt(level) / 100;
					asset.hasCompression = true;
				}

				clearTimeout(this.setCompressionLevelTimeout);
				this.setCompressionLevelTimeout = setTimeout(() => {

					Asset.setAssetProperty(asset, 'compression', parseInt(level) / 100);

				}, 200);

				this.update();

			}
		}
	}
</script>

<style lang="sass">

	aside.aside-menu .project-settings-assets hr
		margin-top: 0.3rem
		margin-bottom: 0.3rem

	.project-settings-assets

		a
			color: #20a8d8
			text-decoration: none
			background-color: transparent
			transition: 0.2s

			&:hover
				color: #2080af
				text-decoration: none

		.assets-list-empty
			padding: 5px
			color: #73818f

		.assets-list
			position: relative
			margin-top: 5px
			border: 1px solid #23282c
			border-radius: 5px
			background-color: #343b41
			font-size: 12px
			overflow: hidden

			.assets-list-item
				position: relative
				user-select: none

				&:not(:first-child)
					border-top: 1px solid rgba(0, 0, 0, 0.1)

				&:hover
					background-color: #2f363c

				.asset-list-main
					display: flex
					position: relative
					justify-content: space-between
					border-top: 1px solid #23282c
					cursor: pointer
					transition: 0.2s
					user-select: none

					&:first-child
						border-top: none

					.asset-list-name
						padding: 5px 0 5px 5px
						max-width: 170px
						overflow: hidden
						text-overflow: ellipsis

						span
							line-height: 14px
							display: block
							white-space: nowrap
							text-overflow: ellipsis
							overflow: hidden
							height: 15px

					.asset-list-edit
						display: flex

						.icon-info
							color: #20a8d8
							font-size: 0.8rem !important
							display: inline-block
							margin-top: 5px

					.progress
						position: absolute
						height: 3px
						bottom: 0
						width: 100%
						background-color: rgba(255,255,255,0.1)
						border-radius: 0

				.props-list
					max-width: 94%
					display: flex
					flex-wrap: wrap
					font-size: 10px
					color: #73818f
					padding-left: 5px
					margin-top: -3px
					cursor: pointer

					.prop-list
						display: flex
						white-space: nowrap

						.prop-name
							display: flex
							white-space: nowrap

					.prop-list:last-child

						.prop-name:last-child

							span
								display: none

					.prop-list:not(:first-child)
						text-transform: lowercase

						.prop-name
							text-transform: none

				.asset-list-item-settings
					position: relative

					.asset-settings
						display: flex
						flex-direction: column
						position: relative
						padding: 5px
						color: #73818f

						.asset-settings-control
							display: flex
							justify-content: space-between
							margin-bottom: 10px

							input.form-control.form-control-sm
								width: 70%
								background-color: #515b65
								border: 1px solid #23282c
								color: #e4e7ea

						.asset-settings-control:last-child
							margin-bottom: 0

						.link
							color: #20a8d8
							text-decoration: none
							background-color: transparent
							-webkit-transition: 0.2s
							transition: 0.2s
							cursor: pointer

							&:hover
								color: #2080af
								text-decoration: none

					.multi-select-control
						flex-direction: column

						.multi-select-control-item
							display: flex
							flex-direction: row
							justify-content: space-between
							margin-bottom: 10px
							width: 100%

						.title
							padding-top: 4px

						.custom-select
							cursor: pointer
							color: #fff
							width: auto
							background: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='%23ffffff' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") no-repeat right 0.75rem center/8px 10px
							background-color: #343b41
							border: 1px solid #23282c
							margin-top: 0

							&.selected
								background-color: #4dbd74

							&.add
								height: 20px
								line-height: 18px
								padding: 0 10px 0 10px
								background: none
								margin-top: 5px

							&.remove
								height: 20px
								line-height: 18px
								padding: 0 5px 0 5px
								background-image: none
								margin-top: 5px
								display: flex
								justify-content: center
								align-items: center
								margin-left: auto
								margin-right: 5px
								color: #f86c6b

						.form-check-input
							margin-top: 0.1rem

					.multi-select-control.low-margin
						margin-bottom: 5px

					.multi-select-control.big-margin
						margin-bottom: 15px

					.multi-select-control.in-a-row
						flex-direction: row

					.multi-select-control.separated
						border-top: 1px solid #23282c
						border-bottom: 1px solid #23282c
						padding-top: 5px
						padding-bottom: 5px

				.asset-list-edit-item
					cursor: pointer
					transition: 0.2s
					padding: 2px 7px
					font-size: 14px
					color: #fff

					&:hover
						color: #20a8d8

					&:last-child
						margin-right: 2px

					&.control-item
						opacity: 0.1

					&.custom
						color: #f86c6b

			.assets-list-item:hover

				.asset-list-edit-item

					&.control-item
						opacity: 1

			.assets-list-item.expanded

				.asset-list-main
					cursor: default

					.asset-list-name

						span
							white-space: normal
							overflow: visible
							height: auto

					.asset-list-edit-item

						&.control-item
							opacity: 1

				.play-on-event-list
					cursor: default

			.assets-list-item.disabled

				.asset-list-main
					color: #73818f

					.asset-list-name
						text-decoration: line-through

		.asset-type-header
			display: flex
			justify-content: space-between

			.asset-type-add
				cursor: pointer
				padding: 0 9px
				font-size: 16px
				transition: 0.2s

				&:hover
					color: #20a8d8

		.progress.add-progress
			height: 5px

		.assets-size
			line-height: 24px
			color: #73818f
			font-size: 12px

</style>
